/* ONECART パーソナライズ（2026-06-25）
   - 閲覧した商品 / 閲覧したショップ / 検索キーワードを localStorage に記録（端末内のみ・サーバ送信なし）。
   - ホーム(#oc-personal)で「為你推薦」3レール（各5商品）を、実証済みの section-render で描画：
       ショップ商品 = /pages/shop/<handle>?section_id=shop-products-with-facets
       検索商品     = /search?q=<kw>&type=product&section_id=main-search
   - ページ下部(#oc-history)に「閲覧履歴（店家・商品）」を localStorage から描画。
   履歴が空の項目は hidden のまま＝新規訪問者にはホーム既存表示のまま（非侵襲）。 */
(function () {
  'use strict';

  var KEY = { products: 'oc_hist_products', shops: 'oc_hist_shops', search: 'oc_hist_search' };
  var CAP = 24;

  function read(k) {
    try { return JSON.parse(localStorage.getItem(k)) || []; } catch (e) { return []; }
  }
  function write(k, arr) {
    try { localStorage.setItem(k, JSON.stringify(arr.slice(0, CAP))); } catch (e) {}
  }
  function remember(k, item, idKey) {
    if (!item || !item[idKey]) return;
    var arr = read(k).filter(function (x) { return x[idKey] !== item[idKey]; });
    item.ts = Date.now();
    arr.unshift(item);
    write(k, arr);
  }
  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function slugFromShopUrl(u) {
    if (!u) return '';
    var seg = u.split('?')[0].replace(/\/+$/, '').split('/');
    return seg[seg.length - 1] || '';
  }
  /* ---------- 1) トラッキング ---------- */
  function track() {
    var p = readJSON('oc-track-product');
    if (p && p.handle) {
      remember(KEY.products, {
        handle: p.handle, title: p.title, url: p.url, img: p.img, price: p.price, shop: p.shop_name
      }, 'handle');
      if (p.shop_url && p.shop_name) {
        remember(KEY.shops, { handle: slugFromShopUrl(p.shop_url), name: p.shop_name, url: p.shop_url, logo: '', coll: p.shop_coll || '' }, 'handle');
      }
    }

    var s = readJSON('oc-track-shop');
    if (s && s.url) {
      remember(KEY.shops, { handle: slugFromShopUrl(s.url), name: s.name, url: s.url, logo: s.logo || '', coll: s.coll || '' }, 'handle');
    }

    if (location.pathname.indexOf('/search') === 0) {
      var q = new URLSearchParams(location.search).get('q');
      if (q) { q = q.trim(); if (q) remember(KEY.search, { q: q }, 'q'); }
    }
  }

  /* ---------- 2) ホームのレール ---------- */
  function fetchCards(url, n) {
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return [];
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // placeholder（aria-hidden の空カード）は除外して実カードのみ先頭 n 枚
        return Array.prototype.slice
          .call(doc.querySelectorAll('.oc-card:not([aria-hidden="true"])'))
          .slice(0, n);
      })
      .catch(function () { return []; });
  }

  function showRail(root, rail, cards, moreUrl) {
    if (!cards.length) return;
    var ul = rail.querySelector('.oc-rail__grid');
    cards.forEach(function (card) {
      var li = document.createElement('li');
      li.className = 'grid__item'; // ネイティブ product-grid と同じセル＝プロダクトカード統一
      li.appendChild(document.importNode(card, true));
      ul.appendChild(li);
    });
    var more = rail.querySelector('.oc-rail__more');
    if (more && moreUrl) more.href = moreUrl;
    rail.hidden = false;
    root.hidden = false;
  }

  // ショップ商品の取得URL：コレクションがあれば created-descending（新着順）で、
  // 無ければショップページ（既定順）にフォールバック。
  // モバイルは grid--2-col のため 5 だと最終行が1個で欠けて見える → 6（2×3）。
  // デスクトップは grid--5-col の1行 → 5。
  var RAIL_N = (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) ? 6 : 5;
  function shopFetchUrl(seed) {
    if (seed.coll) {
      return seed.coll + (seed.coll.indexOf('?') >= 0 ? '&' : '?') +
        'sort_by=created-descending&section_id=main-collection-product-grid';
    }
    return seed.url + '?section_id=shop-products-with-facets';
  }

  // oc-scan.js のスキャン店 url（/pages/shop/<slug>）を待つ。無い/遅い時は 1.5s で [] にフォールバック。
  function scanUrlsReady(cb) {
    var ready = (window.OC_SCAN_READY && typeof window.OC_SCAN_READY.then === 'function')
      ? window.OC_SCAN_READY : Promise.resolve([]);
    var done = false;
    function once(v) { if (done) return; done = true; cb(v || []); }
    ready.then(once, function () { once([]); });
    setTimeout(function () { once([]); }, 1500);
  }

  function renderRails() {
    var root = document.getElementById('oc-personal');
    if (!root) return;

    var used = {}; // 同じショップを複数レールで重複させない
    var purchased = [];
    try { purchased = JSON.parse(root.dataset.purchasedShops || '[]'); } catch (e) {}
    var browsedShops = read(KEY.shops);
    var searches = read(KEY.search);

    // 再次購買（ログイン客＝注文履歴のショップ）
    var rPurchased = root.querySelector('[data-rail="purchased"]');
    if (rPurchased) {
      var sp = purchased.filter(function (x) { return x && x.url; })[0];
      if (sp) {
        used[sp.url] = 1;
        fetchCards(shopFetchUrl(sp), RAIL_N)
          .then(function (cards) { showRail(root, rPurchased, cards, sp.url); });
      }
    }

    // 最近瀏覽（閲覧したショップ）。★スキャンショップ（oc-scan.js）と被る店は重複排除で飛ばす。
    var rBrowsed = root.querySelector('[data-rail="browsed"]');
    if (rBrowsed) {
      scanUrlsReady(function (scanUrls) {
        scanUrls.forEach(function (u) { used[u] = 1; });   // スキャン表示した店を used に入れて除外
        var sb = browsedShops.filter(function (x) { return x && x.url && !used[x.url]; })[0];
        if (sb) {
          used[sb.url] = 1;
          fetchCards(shopFetchUrl(sb), RAIL_N)
            .then(function (cards) { showRail(root, rBrowsed, cards, sb.url); });
        }
      });
    }

    // 依您的搜尋
    var rSearch = root.querySelector('[data-rail="search"]');
    if (rSearch) {
      var kw = searches[0] && searches[0].q;
      if (kw) {
        var kwEl = rSearch.querySelector('.oc-rail__kw');
        if (kwEl) kwEl.textContent = kw;
        var su = '/search?q=' + encodeURIComponent(kw) + '&type=product';
        fetchCards(su + '&section_id=main-search', RAIL_N)
          .then(function (cards) { showRail(root, rSearch, cards, su); });
      }
    }
  }

  /* ---------- 3) 閲覧履歴（ページ下部） ---------- */
  // localStorage は端末で改竄され得るため、href/src は相対・https・protocol-relative のみ許可
  // （javascript:/data: 等を遮断）。テキストは textContent で入れ innerHTML は使わない。
  function safeUrl(u) {
    u = (u == null ? '' : String(u)).trim();
    return /^(\/(?!\/)|https:\/\/|\/\/)/i.test(u) ? u : '';
  }
  function span(cls, text) {
    var s = document.createElement('span');
    s.className = cls;
    if (text != null) s.textContent = text;
    return s;
  }
  function thumb(cls, src) {
    var wrap = span(cls);
    var url = safeUrl(src);
    if (url) {
      var img = document.createElement('img');
      img.src = url;
      img.alt = '';
      img.loading = 'lazy';
      wrap.appendChild(img);
    }
    return wrap;
  }
  // 履歴1件 → <a>（ショップ・チップ／商品ミニカード）。ホーム下部とドロワーで共用。
  function shopChip(s) {
    var url = safeUrl(s.url);
    if (!url) return null;
    var a = document.createElement('a');
    a.className = 'oc-hist-shop';
    a.href = url;
    var av = safeUrl(s.logo) ? thumb('oc-hist-shop__av', s.logo) : span('oc-hist-shop__av');
    if (!safeUrl(s.logo)) av.appendChild(span('', s.name ? s.name.charAt(0).toUpperCase() : '?'));
    a.appendChild(av);
    a.appendChild(span('oc-hist-shop__name', s.name || ''));
    return a;
  }
  function prodCard(p) {
    var url = safeUrl(p.url);
    if (!url) return null;
    var a = document.createElement('a');
    a.className = 'oc-hist-prod';
    a.href = url;
    a.appendChild(thumb('oc-hist-prod__media', p.img));
    a.appendChild(span('oc-hist-prod__title', p.title || ''));
    if (p.price) a.appendChild(span('oc-hist-prod__price', p.price));
    return a;
  }
  // row 要素に履歴を流し込む。1件以上入れば true。
  function fillRow(rowEl, items, builder, cap) {
    if (!rowEl) return false;
    var n = 0;
    items.slice(0, cap).forEach(function (it) {
      var el = builder(it);
      if (el) { rowEl.appendChild(el); n += 1; }
    });
    return n > 0;
  }

  // ホーム下部「瀏覽紀錄」
  function renderHistory() {
    var root = document.getElementById('oc-history');
    if (!root) return;
    var shopBlock = root.querySelector('[data-hist="shops"]');
    var prodBlock = root.querySelector('[data-hist="products"]');
    if (shopBlock && fillRow(shopBlock.querySelector('.oc-history__row'), read(KEY.shops), shopChip, 12)) {
      shopBlock.hidden = false; root.hidden = false;
    }
    if (prodBlock && fillRow(prodBlock.querySelector('.oc-history__row'), read(KEY.products), prodCard, 12)) {
      prodBlock.hidden = false; root.hidden = false;
    }
  }

  // モバイルドロワー内「閲覧したショップ／商品」
  function renderDrawerHistory() {
    var sBlock = document.querySelector('[data-drawer-hist="shops"]');
    var pBlock = document.querySelector('[data-drawer-hist="products"]');
    if (sBlock) {
      // ★ドロワー「Shop」（スキャン店）と被る店は「閲覧したショップ」から除外して揃える。
      scanUrlsReady(function (scanUrls) {
        var seen = {};
        scanUrls.forEach(function (u) { seen[u] = 1; });
        var shops = read(KEY.shops).filter(function (x) { return x && x.url && !seen[x.url]; });
        if (fillRow(sBlock.querySelector('.oc-dh__row'), shops, shopChip, 12)) {
          sBlock.hidden = false;
        }
      });
    }
    if (pBlock && fillRow(pBlock.querySelector('.oc-dh__row'), read(KEY.products), prodCard, 12)) {
      pBlock.hidden = false;
    }
  }

  function run() {
    track(); // トラッキングは全ページで即時（軽量）
    // 描画（section-render fetch を含む）は LCP を邪魔しないよう idle に回す
    var renderUI = function () { renderRails(); renderHistory(); renderDrawerHistory(); };
    if ('requestIdleCallback' in window) {
      requestIdleCallback(renderUI, { timeout: 1800 });
    } else {
      setTimeout(renderUI, 200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
